@if (model) {
  <div nxLayout="grid" class="nx-margin-top-s">
    <div nxRow="">
      <div nxCol="12,12,12,4">
        <div nxRow="">
          <div nxCol="12">
            <app-show-measuring-point-data [withNavigation]="withNavigation"
            [model]="model"></app-show-measuring-point-data>
          </div>
          <div nxCol="12">
            @if (showMap) {
              <app-note-handler [notes]="model.notes" [addNoteSupplier]="addNote()"
              title="{{'measuringDevice.notes' | caption}}"></app-note-handler>
            }
          </div>
        </div>
      </div>
      <div nxCol="12,12,12,8" class="nx-margin-top-s">
        @if (showMap) {
          <app-map height="calc(50vh - 110px)" [models]="[mapModel]" [showYourPosition]="false"
            [startZoom]="13"
          [countryCodes]="[countryCode]"></app-map>
        }
      </div>
      <div nxCol="12" class="nx-margin-top-m">
        <nx-notification-panel class="w-100 text-center">
          <div>
            @for (attachment of model.attachments; track attachment) {
              <app-show-image [image]="attachment" height="200"></app-show-image>
            }
          </div>
        </nx-notification-panel>
      </div>
    </div>
  </div>
}
